import { v4 as uuidv4 } from 'uuid';

const API_HOST = process.env.REACT_APP_API_HOST;
const API_HOST_POS = process.env.REACT_APP_API_HOST_POS;
const COUNTRY = process.env.REACT_APP_COUNTRY;
const CITY_ID = process.env.REACT_APP_API_CITY_ID;

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export async function fetchGetBranchOfficeById(branchOfficeId) {
  const url = `${API_HOST}/v1/branch_offices/${branchOfficeId}`;
  const res = await fetch(url);
  return await res.json();
}

export async function fetchGetProductsByBranchOfficeId(branchOfficeId) {
  const url = `${API_HOST}/v1/countries/${COUNTRY}/cities/${CITY_ID}/branch_offices/${branchOfficeId}/branch_offices_products_lists`;
  const res = await fetch(url);
  return await res.json();
}

export async function fetchGetProductById(branchOfficeId, productId) {
  const url = `${API_HOST}/v1/countries/${COUNTRY}/cities/${CITY_ID}/branch_offices/${branchOfficeId}/branch_offices_products/${productId}`;
  const res = await fetch(url);
  return await res.json();
}

export async function fetchGetOrderById(order_id, uuid) {
  const url = `${API_HOST}/v1/orders/${order_id}/uuid/${uuid}`;
  const res = await fetch(url);
  return await res.json();
}

export async function fetchCreateOrder(data) {
  const url = `${API_HOST}/v1/orders?domain=${window.location.host}`;
  const res = await fetch(url, {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await res.json();
}

export async function fetchPosSale(ticket, amount) {
  const url = `${API_HOST_POS}/v1/api/pos-autoservicio/sale`;
  const res = await fetch(url, {
    method: 'post',
    body: JSON.stringify({ ticket_code: ticket, amount }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await res.json();
}

export async function fetchPosConnection(ticket, amount) {
  const url = `${API_HOST_POS}/v1/api/pos-autoservicio/connection`;
  const res = await fetch(url, {
    method: 'post',
  });
  return await res.json();
}

export async function fetchPosGetInitializationResponse(ticket, amount) {
  const url = `${API_HOST_POS}/v1/api/pos-autoservicio/initialization`;
  const res = await fetch(url, {
    method: 'get',
  });
  return await res.json();
}

export async function fetchPosInitialization(ticket, amount) {
  const url = `${API_HOST_POS}/v1/api/pos-autoservicio/initialization`;
  const res = await fetch(url, {
    method: 'post',
  });
  return await res.json();
}

export async function fetchPosPolling(ticket, amount) {
  const url = `${API_HOST_POS}/v1/api/pos-autoservicio/polling`;
  const res = await fetch(url, {
    method: 'post',
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await res.json();
}

export async function fetchPosCloseDay(ticket, amount) {
  const url = `${API_HOST_POS}/v1/api/pos-autoservicio/close-day`;
  const res = await fetch(url, {
    method: 'post',
  });
  return await res.json();
}

export async function fetchConfirmPosSale(orderId, uuid, tbkResponse) {
  const url = `${API_HOST_POS}/v1/api/sales/confirm?uuid=${uuid}`;
  const res = await fetch(url, {
    method: 'post',
    body: JSON.stringify({ ...tbkResponse, order_id: orderId }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await res.json();
}

export async function fetchLogin(data) {
  const url = `${API_HOST}/v1/login`;
  const res = await fetch(url, {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await res.json();
}

/**
 * Devuelve las sucursales (branch_offices) a las que tiene acceso el
 * usuario asociado al token. Usado para validar que el operador que se
 * loguea en el panel admin del totem tenga permiso sobre la sucursal
 * actual del equipo.
 */
export async function fetchUserBranchOffices(token) {
  const url = `${API_HOST}/v1/home?only=branch_offices`;
  const res = await fetch(url, {
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  });
  return await res.json();
}

export async function fetchCloseDay(companyId, branchOfficeId, token, posResponse) {
  const uuid = uuidv4();
  const url = `${API_HOST}/v1/companies/${companyId}/branch_offices/${branchOfficeId}/devices_closings/${uuid}`;
  const res = await fetch(url, {
    method: 'post',
    body: JSON.stringify({ posResponse }),
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  });
  return await res.json();
}
